import { Component, OnInit, ViewChild } from '@angular/core';
import { CreateCustomerDialogComponent } from '../create-customer-dialog/create-customer-dialog.component';
import { MessageService, ConfirmationService } from 'primeng/api';
import { QuotationCustomerService } from '../../services/quotation-customer.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss'],
  providers: [ConfirmationService]
})
export class CustomerListComponent implements OnInit {
  @ViewChild('customerDialog') customerDialog!: CreateCustomerDialogComponent;

  customers: any[] = [];
  selectedCustomer: any = null;
  loading: boolean = true;
  isHeaderCollapsed = false;
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private customerService: QuotationCustomerService,
  ) {}

  ngOnInit() {
this.loadCustomers();
  }
loadCustomers() {
    this.loading = true;
    this.customerService.getCustomers().subscribe({
      next: (customers) => {
        this.customers = customers;
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load customers',
          life: 3000,
        });
        this.loading = false;
      },
    });
  }
  openNew() {
    this.customerDialog.showDialog();
  }

  editCustomer(customer: any) {
    this.selectedCustomer = customer;
    this.customerDialog.showDialog(customer);
    console.log('Selected customer:', this.selectedCustomer);
  }

onCustomerUpdated(updatedCustomer: any) {
    if (this.selectedCustomer) {
      this.customerService.updateCustomer(this.selectedCustomer.uuid, updatedCustomer).subscribe({
        next: (updated) => {
          const index = this.customers.findIndex(c => c.uuid === this.selectedCustomer.uuid);
          if (index !== -1) {
            this.customers[index] = { ...updated }; // Update with server response
            this.messageService.add({
              severity: 'success',
              summary: 'Successful',
              detail: 'Customer Updated',
              life: 3000,
            });
            this.selectedCustomer = null;
          }
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update customer',
            life: 3000,
          });
        },
      });
    }
  }

deleteCustomer(customer: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this customer?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.customerService.deleteCustomer(customer.uuid).subscribe({
          next: () => {
            this.customers = this.customers.filter(c => c.uuid !== customer.uuid);
            this.messageService.add({
              severity: 'success',
              summary: 'Successful',
              detail: 'Customer Deleted',
              life: 3000,
            });
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to delete customer',
              life: 3000,
            });
          },
        });
      },
    });
  }
  onHeaderCollapse(isCollapsed: boolean) {
    this.isHeaderCollapsed = isCollapsed;
    console.log('Header collapsed:', isCollapsed);
    console.log('Header state changed:', this.isHeaderCollapsed);
  }

onCustomerCreated(newCustomer: any) {
    // Call the service to create the customer in the backend
    this.customerService.createCustomer(newCustomer).subscribe({
      next: (createdCustomer) => {
        this.customers.push(createdCustomer);
        this.messageService.add({
          severity: 'success',
          summary: 'Successful',
          detail: 'Customer Created',
          life: 3000,
        });
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to create customer',
          life: 3000,
        });
      },
    });
  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case 'active':
        return 'success';
      case 'inactive':
        return 'danger';
      case 'pending':
        return 'warning';
      default:
        return 'info';
    }
  }

  getDefaultShippingAddress(customer: any): string {
    const defaultShipping = customer.shippingDetails.find((s: any) => s.isSelectedShipping);
    if (defaultShipping) {
      return `${defaultShipping.companyName}, ${defaultShipping.shippingAddress}`;
    }
    return 'No default shipping address';
  }
}